export const PLAYING = "playing";
export const PAUSED = "paused";
export const STARTED = "started";
export const ENDED = "ended";
export const IDLE = "idle";
